import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { Note } from '@card-software/library';
import { Provider } from '../finance/provider';
import { Yarn } from '../item/yarn';
import { Roll } from '../knitting/roll';
import { Fabric } from '../order/work-order';
import { ProductionCard } from './production-card';

export interface KnittingOrder {
  id?: string;
  workOrderReference?: string;
  workOrderNumber?: string;
  knittingOrderNumber?: string;
  issuedQuantity?: number;
  issuedQuantityKgs?: number;
  fabricQuantityDetails: FabricQuantityDetail[];
  greigeQuantityDetails?: GreigeQuantityDetail[];
  createdBy?: null | string;
  modifiedBy?: string;
  modifiedDate?: Date;
  notes?: Note[];
  productionCardReferences?: string[];
  //DTO properties
  rollsCreated?: number;
  rollsWeighed?: number;
  programmedQuantity?: number;
  locationCode: string;
  status: number;
  rolls?: Roll[];
  fabrics?: Fabric[];
}

export interface FabricQuantityDetail {
  fabricCode: string;
  quantity: number;
  unitOfMeasure: number;
  variantCode: string;
  yarnAndProviderInfos: YarnAndProviderInfo[];
  productionCardReference?: string | ProductionCard;
  fieldToDisplay?: string; // UI only
}
export interface YarnAndProviderInfo {
  yarnCode: string;
  yarn?: Yarn;
  providerReference?: string;
  provider?: Provider;
  providerLotNumber?: string;
}

export interface GreigeQuantityDetail {
  greigeReference: string;
  quantity: number;
  unitOfMeasure: number;
}

export interface KnittingOrderSearchCommand {
  knittingOrderNumber?: string;
  statuses?: number[];
}

export interface YarnAndProviderInfoFormGroup {
  yarn: FormControl<Yarn>;
  provider: FormControl<Provider | null>;
  providerLotNumber: FormControl<string>;
}

export interface FabricQuantityDetailsFormGroup {
  fabric: FormControl<Fabric>;
  quantity: FormControl<number>;
  unitOfMeasure: FormControl<number>;
  productionCardReference: FormControl<ProductionCard | null | string>;
  variantCode: FormControl<string>;
  yarnAndProviderInfos: FormArray<FormGroup<YarnAndProviderInfoFormGroup>>;
}

export interface FabricVariantGroup {
  fieldToDisplay: string;
  fabricQuantityDetail: FabricQuantityDetail;
}

export interface FabricFormGroup {
  fabricCode: string;
  groups: FormGroup[];
  variantControl: FormControl<number>;
  variantOptions: { label: string; value: number }[];
}

export enum KnittingOrderStatus {
  Draft,
  Submitted,
  Approved,
  InProgress,
  Closed,
  Voided,
}
